module.exports = __webpack_public_path__ + "a6858f403b3c3252c87f820fa1acb765.pdf";